import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-wrh-blue-dark text-white p-4" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const footerLogo = '/images/ryan_group_logo.png';
const altText = 'Ryan Group Logo';
const term = 'Terms of Use';
const wrhLink = 'WilliamRyanHomes.com';
const copyRight = '©2021 Ryan Building Group. All Rights Reserved. No offer of any kind is made by this weeb sitee. All prices, plans amentitiees, and/or promotions are subject to change at any time without notice. Please read the important Terems of Use.';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", { class: "flex items-center justify-between mb-2" }, [
      _createElementVNode("img", {
        src: footerLogo,
        alt: altText
      }),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: "#",
          class: "t-14m",
          target: "_blank"
        }, _toDisplayString(term)),
        _createElementVNode("a", {
          href: "#",
          class: "pl-6 t-14m",
          target: "_blank"
        }, _toDisplayString(wrhLink))
      ])
    ]),
    _createElementVNode("p", { class: "t-11r" }, _toDisplayString(copyRight))
  ]))
}
}

})